import { ApolloError, useQuery } from '@apollo/client'
import { EMPLOYEES_AND_APPRAISALS } from '../Queries'
import {
  Country,
  NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQuery,
  NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQueryVariables,
} from '../../../types'

export default (
  companyId: string,
  country: Country,
): {
  data: NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQuery | undefined
  error: ApolloError | undefined
  loading: boolean
  startPolling: (pollInterval: number) => void
  stopPolling: () => void
} => {
  const variables = {
    companyId: companyId,
    country: country,
  }

  const { data, error, loading, startPolling, stopPolling } = useQuery<
    NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQuery,
    NonManagerEmployeesOfCompanyWithCurrentAppraisalMeetingQueryVariables
  >(EMPLOYEES_AND_APPRAISALS, {
    variables: variables,
    fetchPolicy: 'network-only',
  })

  return { data, error, loading, startPolling, stopPolling }
}
